import { Outlet } from 'react-router-dom';
import { useShellAside } from '../../layout/ShellAside';
import SectionPicker from '../../reusable/SectionPicker/SectionPicker';
import { t } from '../../i18n/i18n';
import './PayoutLayout.scss';

/**
 * The sidebar's own sub-nav, in its order — see GROUPS in layout/nav.js.
 *
 * The frame's sub-nav links are text only, so there is no icon to copy for
 * these two. Payout borrows the group's own glyph; Certificates uses the seal
 * the Certificates page puts beside "All certificates (8)" (1:14674), which is
 * the one place the design draws a certificate.
 */
const SECTIONS = [
  { to: '/payout', label: 'Payout', icon: 'nav-payout', end: true },
  { to: '/payout/certificates', label: 'Certificates', icon: 'nav-certificates' },
];

/**
 * Layout route for `/payout/*`.
 *
 * Unlike Affiliate this section has no aside of its own: on a desktop the
 * sidebar's nested Payout / Certificates list is the nav, and the design keeps
 * the full 220px sidebar here. Only the phone needs anything, where that list
 * is inside a sidebar that isn't rendered — so this publishes a picker that
 * shows at that width and nothing at any other.
 *
 * It goes through the shell's aside slot rather than into the pages so it lands
 * under the top bar, in the same place Affiliate's picker does.
 */
export default function PayoutLayout() {
  useShellAside(
    () => (
      <div className="payout-sections shell__aside">
        <SectionPicker
          sections={SECTIONS.map((section) => ({ ...section, label: t(section.label) }))}
          label={t('Payout section')}
        />
      </div>
    ),
    [],
  );

  return <Outlet />;
}
